module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"A Feast For Odin helper"},"fi":{"pageTitle":"A Feast For Odin avustin"}}')
  delete Component.options._Ctor
}
